import PropTypes from "prop-types";
import React from "react";

import { Text, textPropTypes } from "@swa-ui/core";

import { getShortDisplayStationName, getStationName } from "../Stations";

/**
 * ItineraryStation renders a station code/name within a span element something like this:
 * Dallas (Love Field), TX - DAL
 * stationCode can be rendered in different formats.
 * See propTypes to learn about ways to format and style the output.
 */

export const ItineraryStation = (props) => {
  const { className, format, stationCode, textProps } = props;

  return (
    <Text className={className} {...textProps}>
      {getStationDisplay()}
    </Text>
  );

  function getStationDisplay() {
    let content = stationCode;

    if (format === "stationName") {
      content = getStationName(stationCode);
    } else if (format === "shortStationName") {
      content = getShortDisplayStationName(stationCode);
    }

    return content;
  }
};

ItineraryStation.propTypes = {
  /** Classes for positioning the component. */
  className: PropTypes.string,

  /** This format indicates how to display the station name. See Station.js for more info. */
  format: PropTypes.oneOf(["stationCode", "stationName", "shortStationName"]),

  /** Three letter station code in all caps. */
  stationCode: PropTypes.string.isRequired,

  /** Props passed to the underlying Text component. See Text for more details. */
  textProps: PropTypes.shape(textPropTypes),
};

ItineraryStation.defaultProps = {
  format: "stationCode",
};
